import upyun from 'upyun/dist/upyun';
import {getApiHost} from './service';
import {getHomeworkInfo} from '../lib/homework-info';

const homeworkInfo = getHomeworkInfo();
const courseId = Number(homeworkInfo.courseId);
const unitId = Number(homeworkInfo.unitId);
const lessonId = Number(homeworkInfo.lessonId);
const upyunStroage = function (key, homeworkFile, cb, reject) {
    const bucket = new upyun.Bucket('upyun-sb3');
    const getHeaderSign = function (bucket, method, path) { // eslint-disable-line
        return fetch(`//${getApiHost()}/logic/v1/upYun/token?fileName=${key}`)
            .then(response => {
                if (response.status !== 200) {
                    sa.track('token_error', {
                        courseId: courseId,
                        unitId: unitId,
                        lessonId: lessonId,
                        currentUrl: location.href,
                        eventOrigin: 'upyun'
                    });
                    reject();
                    return;
                }
                return response.json();
            })
            .then(res => res.data);
    };
    const client = new upyun.Client(bucket, getHeaderSign);

    client.putFile(key, homeworkFile).then(result => {
        if (!result) {
            sa.track('upload_error', {
                courseId: courseId,
                unitId: unitId,
                lessonId: lessonId,
                currentUrl: location.href,
                eventOrigin: 'upyun'
            });
            reject();
        }
        result && cb(key);
    });
};

export default upyunStroage;
